export default "__VITE_ASSET__CYXGi00D__"